import { defineModule } from '../../engine/module';

// Tenant-facing support UI: a tenant owner/admin grants a platform operator time-boxed access into
// their workspace for troubleshooting, and revokes it. The reports themselves live in the feedback
// module; the operator's cross-tenant triage is the /admin console.
export const supportModule = defineModule({
  name: 'support',
  nav: [
    {
      label: 'Organisation',
      area: 'config',
      order: 10,
      items: [{ label: 'Support access', to: '/support-access', icon: 'life-buoy' }],
    },
  ],
  screens: [
    {
      path: '/support-access',
      resource: 'support-access-grants',
      kind: 'list',
      title: 'Support access',
      subtitle: 'Grant the platform team time-boxed access to help you',
      columns: ['scope', 'reason', 'admin_user_id', 'expires_at', 'revoked_at', 'created_at'],
      query: { sort: '-created_at' },
      form: { fields: ['scope', 'reason', 'admin_user_id', 'expires_at'], mode: 'drawer' },
    },
  ],
});
